import {
    ContentItemViewNodesType,
    DataNode,
} from 'components/WorkspaceEditor/types'
import { TrackedChange } from 'models/changes'
import { useCallback } from 'react'
import { getContentItemViewNodeElementMapping } from '../../../utils/TrackChangesPanelUtils'
import { useMemoizedTreeSearch } from './useMemoizedTreeSearch'

export const useAttemptScrollWithCurrentContent = (
    contentItemViewNodes: Partial<ContentItemViewNodesType>[],
    scrollToElement: (id: string) => Promise<void>,
    treeData: Partial<DataNode>[]
) => {
    const getTreeNodeInfoById = useMemoizedTreeSearch(treeData as DataNode[])

    return useCallback(
        async (
            scrollToId: string,
            correspondingTrackChange: TrackedChange
        ): Promise<boolean> => {
            try {
                const contentItemMapping = getContentItemViewNodeElementMapping(
                    contentItemViewNodes
                )
                const mappingKeys = Object.keys(contentItemMapping)
                const hasContent = mappingKeys.some((key) =>
                    key.includes(correspondingTrackChange.contentItemElementId)
                )

                if (hasContent) {
                    const nodeInfo = getTreeNodeInfoById(scrollToId)
                    const bestScrollId = nodeInfo?.isDirectMatch
                        ? scrollToId
                        : correspondingTrackChange.contentItemElementId

                    await scrollToElement(bestScrollId)
                    return true
                } else {
                    return false
                }
            } catch (error) {
                console.error(
                    'Error in attemptScrollWithCurrentContent:',
                    error
                )
                return false
            }
        },
        [contentItemViewNodes, treeData, scrollToElement, getTreeNodeInfoById]
    )
}
